<template>
    <div class="captail_wrap registrationSteps position-relative fullLoader p-0">
		<loader v-if="pageLoader"></loader> 
         <div class="middle_section m-0 mobdesign">
         <div class="top_searchbars">
            <div class="col-12">
               <div class="cap_logo mob-text-center noBG">
                    <router-link to="/home"><img src="../../../../static/website/images/logo.svg" alt="Captail wallet"></router-link>
                </div>
            </div>
         </div>
        <div class="mid_scroll_content d-flex align-items-center justify-content-center mt-custom">
            <section class="stepsForm-include border-0 w-100">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-5 stepBorder box-shadow text-center">
                    	<div class="lt-aler-message" v-if="notification_msg != ''">
	                    	<alert-notification/>
	                    </div>
                        <!-- <h3 class="text-center">Confirm Your Email</h3>
                        <h4>psharma1@finvasia.in</h4> -->
                        <!-- <p>Check your Spam or Junk folder if the email has not arrived. Incorrect Email? <router-link :to="'/email-step'">Edit Email Address</router-link></p> -->
                        <form class="mt-4" action="#">
                            <h4 class="mb-4">Enter Verification code </h4>
                            <div class="form-group partitioned">
								<vie-otp-input
									inputClasses="form-control"
									:numInputs="6"
									separator=" "
									:shouldAutoFocus="true"
									@on-change="handleOnChange"
									@on-complete="handleOnComplete"
								/>
								<input v-validate="'required'"  name="otp" type="text" v-model="otp" style="display: none;">
								<p class="error" v-if="errors.first('otp') && submitted">The otp is required.</p>
                            </div>
                            <div class="submitButton text-center pb-1 mt-3 mt-md-5">
                                <input type="button" class="cap_btn blue px-4 large_btn" value="Save & Continue"  :class="(pageLoader)?'disabled':''" v-on:click.stop.prevent="submit">
                                <!-- <div class="submitButton d-block text-center mt-2">
                                <router-link to="/register">Back</router-link>
                            </div> -->
                            </div>
                            <div class="termsForm mt-3">
                                <!-- <p v-if="!resend">Code hasn't arrived? <a href="#">you can retry in {{countDown}} seconds</a> or <a href="#">contact us</a></p> -->
								 <p >Use the 6-digit code we sent to your mailbox to verify your email address. Please check your Spam foler. Not received?  <a href="#"  :class="(pageLoader)?'disabled':''" v-on:click.stop.prevent="resendOtp()">Resend Code (CTA)</a></p> 

                                <p >Incorrect Email? <router-link to="/register">Change Email</router-link></p>

                            </div>
                            
                        </form>
                    </div>
                </div>
            </section>
        </div>
        </div>
    </div>
</template>

<script>
import { Const } from '@/plugins/registerSteps/provider/lib/const.cls.ts'
import { registerStepsMixins } from '@/plugins/registerSteps'
export default {
    name: 'step-two',
	mixins: [registerStepsMixins],
    data() {
        return {
			otp : '',
			pageLoader : false,
			notification_msg:'',
            notification_type:'',
			submitted : false,
			countDown : 30,
			resend : false,
			isError : false
		}
    },
	methods: {
		handleOnComplete(value) {
			this.otp = value
		},
		handleOnChange(value) {
			this.otp = value
		},
		countDownTimer() {
			if(this.countDown > 0) {
				setTimeout(() => {
					this.countDown -= 1
					this.countDownTimer()
				}, 1000)
			}else{
				this.resend = true
			}
		},
		resendOtp(){
			if(this.pageLoader){return;}
			const _that = this
			let input_json={
				'globalParams' :{
					'email' : _that.step2.email, 
					'account_type' :  _that.step2.account_type,
					'residence_country': _that.step2.residence_country
				},
				'localParams' :{ "parameter" : _that ,'page':'otp_step'}
			}
			_that._runStep1(input_json)
		},
		submit(){
			if(this.pageLoader){return;}
			const _that = this
			this.submitted = true;
			this.$validator.validate().then(valid => {
				if (valid) {
					let input_json={
						'globalParams' :{
							'otp' : _that.otp, 
							'transaction_id' :  _that.step2.transaction_id
						},
						'localParams' :{ "parameter" : _that }
					}
					_that._runStep2(input_json)
				}
			})
		}
	},
	created(){
		if(localStorage.getItem('step2')){
			this.$store.commit(Const.SET_STEP2,  JSON.parse(localStorage.getItem('step2')))
			this.countDownTimer()
		}else{
			this.router.replace('/register')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/registerSteps/otp_step.vue